import type { useMessagesRapides } from '../api/useComposeur';
import { echecSansDonnee } from '../helpers/requete';
import { t } from '../i18n/langue';

import BottomSheet from './BottomSheet';
import Button from './Button';
import EtatErreur from './EtatErreur';
import Text from './Text';

/**
 * La feuille des messages rapides, sous « Outils de rédaction » — extrait de #84.
 *
 * Elle REMPLIT le brouillon, elle n'envoie pas : on relit avant d'envoyer un texte
 * pré-écrit à une cliente. Des messages déjà reçus restent proposés quand un
 * rechargement échoue (audit 2026-09-23, A6).
 */
interface FeuilleMessagesRapidesProps {
    ouverte: boolean;
    onClose: () => void;
    rapides: ReturnType<typeof useMessagesRapides>;
    onChoisir: (contenu: string) => void;
}

export default function FeuilleMessagesRapides({ ouverte, onClose, rapides, onChoisir }: FeuilleMessagesRapidesProps) {
    return (
        <BottomSheet
            ouverte={ouverte}
            onClose={onClose}
            libelle={t('composeur.rapides.titre')}
            libelleFermeture={t('composeur.rapides.fermer')}
        >
            {rapides.isLoading && (
                <Text variante="petit" ton="attenue">
                    {t('commun.chargement')}
                </Text>
            )}
            {echecSansDonnee(rapides) && <EtatErreur onReessayer={() => void rapides.refetch?.()} />}
            {!rapides.isLoading && !echecSansDonnee(rapides) && (rapides.data?.data ?? []).length === 0 && (
                <Text variante="petit" ton="attenue">
                    {t('composeur.rapides.aucun')}
                </Text>
            )}
            {(rapides.data?.data ?? []).map((rapide) => (
                <Button
                    key={rapide.id}
                    libelle={rapide.title}
                    variante="discret"
                    alignement="debut"
                    pleineLargeur
                    onPress={() => onChoisir(rapide.content)}
                />
            ))}
        </BottomSheet>
    );
}
